import styled from 'styled-components'
import { cyberColors, greyGradient } from '../../../../lib/colors'
interface Roll_Style_Props {
  under?: boolean
  width?: string
  height?: string
  lowercase?: boolean
  fontSize?: string
  shadow?: boolean
}

interface Wrapper_porps {
  flexDirection?: 'column' | 'row' | string
  margin?: string
}

interface Input_style_props {
  height?: string
  fontSize?: string
}

interface Candle_style_props {
  height: string
  rotate: string
  left: number
  bg: 'grey' | 'green' | string
}

interface Result_style_props {
  res?: boolean
}

interface Train_styled_props {
  down: string
  //   bg: 'blue' | 'grey' | 'green' | string
}
export const SliderWrapper = styled.div`
  width: 100%;
  padding: 18px;
  border-radius: 4px;
  background: ${cyberColors.greyDark};
  margin-top: 10px;
  /* height: 40px; */
  display: flex;
  align-items: center;
`

export const OperationWrapper = styled.div`
  display: flex;
`
export const Progress = styled.div`
  border-radius: 4px;
  width: 84%;
  height: 4px;
  /* border: 1px solid #622d32; */
  outline: 1px solid #622d32;
  background: ${cyberColors.redGradient};
  position: relative;
  svg {
    position: absolute;
    right: -14px;
    top: -12px;
  }
  div {
    position: absolute;
    right: -13px;
    top: -32px;
  }
`
export const Tooltip = styled.div`
  border-radius: 4px;
  border: 2px solid #35353f;
  background: ${cyberColors.greyDark};
  font-size: 12px;
  color: #ffffff;
  display: flex;
  align-items: center;
  padding: 1px;
  p {
    margin-top: 2px;
  }
`
export const Slider = styled.div`
  border-radius: 4px;
  width: 100%;
  background: #545468;
`
export const ButtonWrapper = styled.div<Wrapper_porps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: ${({ margin }) => (margin ? margin : '10px 0 0')};
  flex-direction: ${({ flexDirection }) =>
    flexDirection ? flexDirection : 'row'};
`

export const Roll = styled.div<Roll_Style_Props>`
  background: ${({ under }) =>
    under ? cyberColors.redGradient : cyberColors.blueGradient};
  ${({ shadow, under }) =>
    shadow
      ? 'box-shadow: none;'
      : `box-shadow: ${
          under
            ? 'inset 0px -3px 0px #db2d2d'
            : 'inset 0px 3px 0px rgb(27 51 148)'
        };`}

  border-radius: 6px 6px 4px 4px;
  text-transform: ${({ lowercase }) => (lowercase ? 'lowercase' : 'uppercase')};
  color: #ffffff;
  font-size: ${({ fontSize }) => (fontSize ? fontSize : '20px')};
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${({ height }) => (height ? height : '50px')};
  width: ${({ width }) => (width ? width : '148.5px')};
  padding: 7px 5px 5px;
  p {
    margin-left: 10px;
    margin-top: 3px;
  }
  svg {
    margin-bottom: 5px;
  }
  span {
    /* margin-top: 2px; */
    color: #ffb7b7;
    margin: 0px 10px 0 5px;
  }
`
export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
`

export const Content = styled.div<Input_style_props>`
  background: ${cyberColors.greyDark};
  border-radius: 4px;
  box-shadow: inset 0px -2px 0px #35353f;
  width: 148.5px;
  height: ${({ height }) => (height ? height : '42px')};
  text-transform: uppercase;
  padding: 2px 10px 0;
  span {
    color: ${cyberColors.greyText};
    font-size: 12px;
  }
  p {
    color: #ffffff;
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '20px')};
  }
  div {
    display: flex;
    justify-content: space-between;
  }
  .switcher {
    width: 32px;
    height: 16px;
    background: #35353f;
    border-radius: 34px;
    position: relative;

    :after {
      content: '';
      position: absolute;
      height: 12px;
      width: 12px;
      right: 2px;
      top: 2px;
      background: ${cyberColors.blueGradient};
      border-radius: 50%;
    }
    p {
    }
  }
`
export const ChartWrapper = styled.div`
  position: relative;
  height: 200px;
  .separator {
    position: absolute;
    top: 50%;
    left: 0;
  }
  .horizontal {
    height: 100%;
  }
  .vertical {
    position: absolute;
    /* transform: rotate(90deg); */
  }
  .red {
    position: absolute;
    width: 100%;
    bottom: -10px;
  }
  .blue {
    position: absolute;
    width: 100%;
    top: 20px;
  }
`

export const Candle = styled.div<Candle_style_props>`
  position: absolute;
  width: 9px;
  top: 50%;
  left: ${({ left }) => left + 'px'};
  /* margin: 0 10px; */
  height: ${({ height }) => height};
  background: ${({ bg }) =>
    bg === 'green'
      ? `linear-gradient(178.89deg, #5C8D1D 14.22%, #5E911E 45.28%, rgba(114, 173, 39, 0.2) 99.05%);`
      : `linear-gradient(178.89deg, #393A4B 14.22%, #393A4B 57.24%, rgba(57, 58, 75, 0.2) 99.05%);`};
  transform: ${({ rotate, height }) =>
    rotate === '1' ? 'rotate(180deg)' : `rotate(0deg) translateY(-${height})`};

  border-radius: 2px 2px 0px 0px;
`
export const ScoresWrapper = styled.div`
  height: 139.04px;
  width: 315px;
  position: relative;
`

export const BackgroundWrapper = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 2;
  width: 88%;
  height: 100%;
  background: linear-gradient(
    0deg,
    rgba(28, 28, 33, 1) 0%,
    rgba(43, 44, 58, 1) 100%
  );
  transform: translateZ(100px) perspective(10px) rotateX(1deg) translateX(16px);
  border-radius: 16px;
  z-index: 2;
`
export const Left = styled.div`
  position: absolute;
  left: 0.5px;
  top: -4px;
  width: 59%;
  height: 95%;
  z-index: -1;
  border-top-left-radius: 16px;
  border-bottom-left-radius: 16px;
  transform: translateZ(100px) perspective(6.5px) rotateX(1deg)
    translateX(16.5px);
  background: linear-gradient(
    322deg,
    rgba(61, 65, 81, 0.8981967787114846) 4%,
    rgba(61, 65, 81, 1) 6.73%,
    rgba(61, 65, 81, 1) 9.94%,
    rgba(61, 65, 81, 1) 15.26%,
    rgba(61, 65, 81, 1) 33.7%,
    rgba(61, 65, 81, 1) 69%,
    rgba(238, 57, 57, 1) 82.72%,
    rgba(238, 57, 57, 1) 98.02%
  );
`
export const Right = styled.div`
  position: absolute;
  right: 1px;
  top: -6.3px;
  width: 59%;
  height: 95%;
  -webkit-transform: translateZ(100px) perspective(4.5px) rotateX(1deg)
    translateX(-30.5px);
  -ms-transform: translateZ(100px) perspective(4.5px) rotateX(1deg)
    translateX(-30.5px);
  transform: translateZ(100px) perspective(5px) rotateX(1deg)
    translateX(-22.5px);
  background: ${greyGradient};
  border-top-right-radius: 16px;
  border-bottom-right-radius: 16px;
`
export const Separator = styled.div`
  background: linear-gradient(
    0deg,
    rgba(61, 65, 81, 0) 0%,
    rgb(61, 65, 81) 20%,
    rgb(61, 65, 81) 80%,
    rgba(61, 65, 81, 0) 100%
  );
  position: absolute;
  height: 59px;
  width: 1px;
  z-index: 2;
  right: 50%;
  top: 20%;
  transform: translateZ(300px) translateX(50%);
`
export const Result = styled.div<Result_style_props>`
  text-align: center;
  span {
    text-transform: uppercase;
    color: ${cyberColors.greyText};
    font-size: 14px;
  }
  p {
    font-size: 44px;
    text-shadow: 0px 4px 14px rgba(0, 0, 0, 0.25);
    background: ${({ res }) => (res ? cyberColors.redGradient : '#393A4B')};
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    clip-path: inset(1px 0.5px);
  }
`
export const Board = styled.div`
  position: absolute;
  width: 85%;
  height: 100%;
  z-index: 2;
  padding: 25px 30px 30px;
  display: flex;
  justify-content: space-between;
  transform: translateZ(200px);
  left: 20px;
`
export const TrainWrapper = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  bottom: 25px;
  right: 17px;
`
export const Train = styled.div<Train_styled_props>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px 8px;
  max-height: 14px;
  min-width: 34px;
  margin-right: 2px;
  z-index: 3;
  .gradient {
    position: absolute;
    user-select: none;
    pointer-events: none;
    height: 100%;
    width: 66px;
    background: linear-gradient(
      270.09deg,
      rgba(28, 28, 34, 0.77) 1.56%,
      rgba(32, 32, 39, 0) 93.33%
    );
    right: 60px;
    top: 0;
    z-index: 3;
  }
  &&.history {
    width: 64px;
    margin-right: 0px;
    z-index: 4;
    svg,
    p {
      z-index: 4;
    }
  }
  svg {
    width: 100%;
    position: absolute;
    z-index: 0;
    transform: ${({ down }) =>
      down === '1' ? 'rotate(180deg)' : 'rotate(0deg)'};
  }
  p {
    color: ${cyberColors.whiteText};
    font-size: 10px;
    z-index: 1;
    transform: translateY(1px);
    text-transform: uppercase;
    white-space: nowrap;
  }
`
